import React from 'react';
import PageSelection from '../popover/pageSelection/PageSelection';
import ComponentTabs from './ComponentTabs';
import { UilAngleRight } from '@iconscout/react-unicons';
import { Box, Button, Stack, Text } from '@chakra-ui/react';
import { availableComponents } from '../../utils/layoutConfig';
import theme from '../../utils/ChakraTheme';
import { ChakraProvider } from '@chakra-ui/react';
import SelectCanvasResolution from './SelectCanvasResolution';
import PopoverEditCSSVariables from '../popover/PopoverEditCSSVariables';
import { scrollBarStyle } from '../../utils/layoutConfig';
import PopoverEditGlobalTypography from '../popover/PopoverEditGlobalTypography';
import { useSelector } from 'react-redux';
import { visualizationMode } from '../../redux/visualizationModeSlice';
import MergeVariables from './MergeVariables';

const LeftMenuWM = ({
	noMarginTop,
	viewId,
	setRecentCommitsIsOpen,
	tabIndex,
	setTabIndex,
	leftDrawerIsOpen,
	setLeftDrawerIsOpen,
	setComponentList,
	filteredComponentList,
	componentList,
	setComponents,
}) => {
	const VMMode = useSelector(visualizationMode);
	//get components
	React.useEffect(() => {
		setComponentList(availableComponents);
	}, []);

	if (VMMode) {
		return '';
	}

	return (
		<ChakraProvider theme={theme} resetCSS={false}>
			<Box
				bg={'white'}
				mt={noMarginTop ? '0' : '72px'}
				zIndex={100}
				boxShadow="base"
				transition={'0.2s'}
				mr={leftDrawerIsOpen ? '8px' : 0}
				height="100%"
				position="relative"
				w={leftDrawerIsOpen ? '215px' : 0}
				top={0}
			>
				<Box overflowY={'auto'} overflowX={'hidden'} sx={scrollBarStyle} height="100%">
					<PageSelection />
					<Stack ml={5} mt={2} direction="row" gap={0}>
						<PopoverEditCSSVariables viewId={viewId} />
						<PopoverEditGlobalTypography viewId={viewId} />
					</Stack>
					<Box ml={5} mt={2}>
						{/* <SelectDraggableComponent/> */}
						<Text size={'sm'} fontWeight={'700'}>
							Componentes
						</Text>
						<ComponentTabs
							{...{
								setRecentCommitsIsOpen,
								tabIndex,
								setTabIndex,
								filteredComponentList,
								componentList,
								setComponents,
							}}
						/>
					</Box>
					{/* <MergeVariables /> */}
				</Box>
			</Box>
		</ChakraProvider>
	);
};
const LeftMenu = React.memo(LeftMenuWM);
export default LeftMenu;
